module.exports = __webpack_public_path__ + "na.a9914e6af7e04b90ba4d.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/na.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/na.svg
// module chunks = styles